import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { stepsActions } from '../../../store/modules/steps/reducer';
import { getFileslotId, checkFileValidity } from '../../utils';
import { CustomFormFieldState } from '../../FormControls/CustomFormField/CustomFormField';
import { FileUploadData, FormStep } from '../../../model/global';
interface Props {
	fileUploadData: FileUploadData | undefined;
	stepTemplate: FormStep['stepTemplate'];
}

const FormFiles: React.FC<Props> = ({ fileUploadData, stepTemplate }) => {

	const dispatch = useDispatch();
	const [uploads, setUploads] = useState<CustomFormFieldState[]>([]);
	const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, fileIndex: number) => {

		if (!(event.target.files && event.target.files.length > 0)) return;

		const theFile = event.target.files[0];
		const validationError = checkFileValidity(theFile, uploads, (fileUploadData || {} as FileUploadData))

		// update field value
		const {
			//name,
			//value,
			required,
			validity: { valid },
		} = event.target;
		const newFile: CustomFormFieldState = {

			name: `file-${fileIndex + 1}`,
			// value: newUploads.map(f => f.name), // todo...
			value: theFile.name,
			required,
			valid: validationError === '',
			invalidReason: validationError,
			originalField: Object.assign({}, (fileUploadData || {})) as any,
			fileDetails: {
				fileName: theFile.name,
				fileSize: theFile.size,
				fileType: theFile.type,
				fileIndex: fileIndex,
				lastModified: theFile.lastModified,
			},
		}

		// update file at index or insert a new one
		const updating = uploads.length >= fileIndex + 1;

		let newUploads: CustomFormFieldState[];

		if (updating) {
			newUploads = [...uploads]
			newUploads[fileIndex] = newFile;
		}
		else newUploads = [...uploads, newFile];
		setUploads(newUploads);

		dispatch(stepsActions.updateStepPayloadValues({
			stepTemplate,
			stepPayload: newUploads,
		}));
	}


	const maxNumberOfFiles = fileUploadData ? fileUploadData.maxFileSlots : 10;
	const required = fileUploadData ? !!fileUploadData.requiresAtLeastOneFile : false;

	return (
		<div style={{ height: 0 }}>
			{
				[...new Array(maxNumberOfFiles)].map((f, fileIndex) => {
					const fileId = getFileslotId(fileIndex);
					return (
						<input
							type="file"
							tabIndex={-1}
							key={fileId}
							id={fileId}
							required={required}
							// value={uploads[fileIndex].value}
							name={'files[]'}
							className={'hidden-file'}
							onChange={e => changeHandler(e, fileIndex)}
						/>
					)
				})
			}
		</div>
	);
};

export default memo(FormFiles);

